module.exports = __webpack_public_path__ + "img/Slide13.58e0ebf6.png";